// Author thq
// Date 2021-11-02 15:06:10

import * as model from "@/model/em/spareparts/EmSppSparePartsCatSpcModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSppSparePartsCatSpc(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_SPAREPARTS_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'emSppSparePartsCatSpc',
        modelFilter: model.filter
    })
    .buildStore()
